// Shutdown only: the unused PostHog loader has been removed from index.html.
// A bounded guard covers an initialized legacy SDK in an older SPA document.
let pending = null;
export const stopLegacyReplay = () => {
  if (typeof window === 'undefined') return false;
  const sdk = window.posthog;
  if (!sdk || sdk.__loaded !== true) return false;
  try {
    if (typeof sdk.stopSessionRecording === 'function') sdk.stopSessionRecording();
    if (typeof sdk.opt_out_capturing === 'function') sdk.opt_out_capturing();
    return true;
  } catch { return false; }
};
export const guardLegacyReplay = () => {
  if (typeof window === 'undefined') return;
  if (stopLegacyReplay()) { if (pending) window.clearInterval(pending); pending = null; return; }
  if (pending) return;
  let attempts = 0;
  pending = window.setInterval(() => {
    attempts += 1;
    if (stopLegacyReplay() || attempts >= 30) { window.clearInterval(pending); pending = null; }
  }, 100);
};